import React, { useEffect, useRef } from 'react'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);



const Benifits = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);
  
    useEffect(() => {
      const cards = cardRefs.current;
  
      const initialPositions = [
        { x: 0, y: 100, opacity: 0 },
        { x: 0, y: 150, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
      ];
  
      cards.forEach((card, index) => {
        gsap.fromTo(
          card,
          initialPositions[index], 
          {
            x: 0,
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 100%",
              toggleActions: "play none none none",
            //   markers: true
            },
          }
        );
  
        gsap.set(card, { transformOrigin: "center" });
  
        card.addEventListener("mouseenter", () => {
          gsap.to(card, { scale: 1.05, duration: 0.3 });
        });
  
        card.addEventListener("mouseleave", () => {
          gsap.to(card, { scale: 1, duration: 0.3 });
        });
      });
    }, []);
    return (
        <>
            <section className='benifitsprnt'>
                <div className="custom-container" ref={sectionRef}>
                    <div className="beniftschlprnt">
                        <h2>Key Benefits</h2>
                        <div className="benifitscardsprnt">
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[0] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg.png" alt="" />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <path d="M42 21V38C42 39.0609 41.5786 40.0783 40.8284 40.8284C40.0783 41.5786 39.0609 42 38 42H10C8.93913 42 7.92172 41.5786 7.17157 40.8284C6.42143 40.0783 6 39.0609 6 38V10C6 8.93913 6.42143 7.92172 7.17157 7.17157C7.92172 6.42143 8.93913 6 10 6H35" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                    <path d="M18 22L24 28L44 8" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                </svg>
                                <h3>Authentic Expression</h3>
                                <p>Customize your profile to reflect who you truly are.</p>
                            </div>
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[1] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg2.png" alt="" />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <path d="M40 25.9976C40 35.9976 33 40.9976 24.68 43.8976C24.2443 44.0452 23.7711 44.0382 23.34 43.8776C15 40.9976 8 35.9976 8 25.9976V11.9976C8 11.4672 8.21071 10.9585 8.58579 10.5834C8.96086 10.2083 9.46957 9.9976 10 9.9976C14 9.9976 19 7.5976 22.48 4.5576C22.9037 4.1956 23.4427 3.9967 24 3.9967C24.5573 3.9967 25.0963 4.1956 25.52 4.5576C29.02 7.6176 34 9.9976 38 9.9976C38.5304 9.9976 39.0391 10.2083 39.4142 10.5834C39.7893 10.9585 40 11.4672 40 11.9976V25.9976Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.78662 23H45.213" stroke="#E0ECFA" stroke-width="2.5" stroke-linecap="square" stroke-linejoin="round" />
                                </svg>
                                <h3>Privacy at the Core</h3>
                                <p>Control what you share and with whom.</p>
                            </div>
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[2] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg3.png" alt="" />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                    <path d="M32.9998 38.5C32.9998 34.6102 31.4546 30.8797 28.7041 28.1291C25.9535 25.3786 22.223 23.8334 18.3332 23.8334C14.4433 23.8334 10.7128 25.3786 7.96227 28.1291C5.21174 30.8797 3.6665 34.6102 3.6665 38.5" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                    <path d="M18.3332 23.8333C23.3958 23.8333 27.4998 19.7293 27.4998 14.6667C27.4998 9.60406 23.3958 5.5 18.3332 5.5C13.2706 5.5 9.1665 9.60406 9.1665 14.6667C9.1665 19.7293 13.2706 23.8333 18.3332 23.8333Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M40.3331 36.6667C40.3331 30.4883 36.6665 24.75 32.9998 22C34.2051 21.0957 35.1689 19.9083 35.8058 18.5428C36.4428 17.1773 36.7334 15.6759 36.6518 14.1713C36.5703 12.6667 36.1191 11.2055 35.3382 9.91686C34.5573 8.62823 33.4708 7.55197 32.1748 6.78333" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" />
                                </svg>
                                <h3>Unified Identity</h3>
                                <p>Manage all your digital personas in one space</p>
                            </div>
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[3] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg4.png" alt="" />
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                    <path d="M20.0002 11.6667C22.3013 11.6667 24.1668 9.80123 24.1668 7.50004C24.1668 5.19885 22.3013 3.33337 20.0002 3.33337C17.699 3.33337 15.8335 5.19885 15.8335 7.50004C15.8335 9.80123 17.699 11.6667 20.0002 11.6667Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.4883 12.0117L12.0117 15.4883" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                    <path d="M7.50016 24.1667C9.80135 24.1667 11.6668 22.3012 11.6668 20C11.6668 17.6989 9.80135 15.8334 7.50016 15.8334C5.19898 15.8334 3.3335 17.6989 3.3335 20C3.3335 22.3012 5.19898 24.1667 7.50016 24.1667Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M13.7505 20H26.2498" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                    <path d="M32.5002 24.1667C34.8013 24.1667 36.6668 22.3012 36.6668 20C36.6668 17.6989 34.8013 15.8334 32.5002 15.8334C30.199 15.8334 28.3335 17.6989 28.3335 20C28.3335 22.3012 30.199 24.1667 32.5002 24.1667Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M24.4326 28.0674L28.0674 24.4326" stroke="#FF0083" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round" />
                                    <path d="M20.0002 36.6667C22.3013 36.6667 24.1668 34.8012 24.1668 32.5C24.1668 30.1989 22.3013 28.3334 20.0002 28.3334C17.699 28.3334 15.8335 30.1989 15.8335 32.5C15.8335 34.8012 17.699 36.6667 20.0002 36.6667Z" stroke="#FF0083" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <h3>Seamless Connections</h3>
                                <p>Use your profile to join groups, transact, and engage effortlessly.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Benifits